export const skillsData = {
    "Web Development": [
      "HTML",
      "CSS",
      "JavaScript",
      "C#"
    ],
    "Frameworks & Libraries": [
      "React",
      "React Native",
      "Next.js",
      "Redux",
      "React Query",
      "Zustand",
      "ASP.NET",
      "Tailwind CSS",
      "Material UI",
      "shadcn/ui"
    ],
    "Backend & Databases": [
      "Node.js",
      "Express.js",
      "PostgreSQL",
      "SQLite",
      "Firebase",
      "Supabase",
    ],
    "Testing & Tools": [
      "Jest",
      "Jasmine",
      "React Testing Library",
      "Postman",
      "Docker",
      "Git",
      "Expo"
    ],
    "Other Technologies": [
      "DevExtreme",
      "TipTap (Collaborative Editor)",
      "zDarcy (Image/Video Editor)",
      "Figma (UI/UX Design)"
    ]
  };
  